<div class="banner_header">
    <div class="col-md-12">
        <h2>CBT </h2>
        <a href="https://nimionlineadmission.in/aitt/" target="_blank" class="atag_cls"> <i class="fa fa-user"></i> Login</a>
    </div>
</div>

<div class="container big_padd">
    <div class="row download_section">
        <div class="col-md-12">
            <h2>CTS Online Examinations</h2>
        </div>
    </div>

        <div class="row">
            <div class="col-md-12 step_cls">
               <!-- <p> AITT exam are being conducted online for all ITI students in two shift per day.
                The theory exam comprises of 60 questions for Non - Engineering trades & Engineering second year trades and 80 questions for Engineering trades.
                </p> -->
                <p> AITT exam are being conducted online for all ITI students. The theory exam comprises of 60 questions for Non - Engineering trades & Engineering second year trades and 80 questions for Engineering trades.</p>

                <p> Exam will consist of Multiple-Choice Question with 40 /20 questions per subject and each question will carry equal marks specific to subjects. </p>

            </div>

                <hr>

                <div class="col-md-12 step_cls">
                  <section class="section_box_one">
              
                          <table>
                            <thead>
                                <th>Subject</th>
                                <th>Trade Duration & Admission Year</th>
                                <th>No. of Questions</th>
                                <th>Max. Marks</th>
                                <th>Time duration</th>
                            </thead>
              
                            <tr>
                              <td>Trade Theory</td>
                              <td><p> A. One Year Trade - (Trainees admitted in 2018 & 2019) </p>
                                <p> B. Two Year Trade - (Trainees admitted in 2018 & 2019) </p></td>
                                <td>40 </td>
                              <td>100 </td>
                              <td>90 minutes / 1.5 Hours</td>
                            </tr>
              
                            <tr>
                              <td>Trade Theory</td>
                              <td><p> A. One Year Trade - (Trainees admitted in 2018 & 2019) </p>
                                <p> B. Two Year Trade - (Trainees admitted in 2018 & 2019) </p></td>
                                <td>40 </td>
                              <td>100 </td>
                              <td>90 minutes / 1.5 Hours</td>
                            </tr>
              
                            <tr>
                              <td>Workshop Cal & Science (WCS)</td>
                              <td><p> A. One Year Trade - (Trainees admitted in 2018 & 2019) </p>
                                <p> B. Two Year Trade - (first year trainees admitted in 2019) </p></td>
                                <td>20 </td>
                              <td>50 </td>
                              <td>45 minutes</td>
                            </tr>
              
                          </table>
                  </section>
                </div>

        </div>


    <!--Content Start-->


<hr>

<div class="row download_section">
  <div class="col-md-12">
      <h2>CITS Online Examinations</h2>
  </div>
</div>

  <div class="row">

          <div class="col-md-12 step_cls">
           
            <section class="section_box_one">
        
                    <table>
                      <thead>
                          <th>Subject</th>
                          <th>No. of Questions</th>
                          <th>Time duration</th>
                      </thead>
        
                      <tr>
                        <td>Trade Theory</td>
                          <td>50 </td>
                        <td>2 hours</td>
                      </tr>
        
                      <tr>
                        <td>Workshop Calculation & Science</td>
                          <td>25 </td>
                        <td>90 minutes / 1.5 Hours</td>
                      </tr>
        
                      <tr>
                        <td>Training Methodology</td>
                          <td>50 </td>
                        <td>2 hours</td>
                      </tr>
        
                      <!--<tr>
                        <td>Vocational Science& Calculation</td>
                          <td>25 </td>
                        <td>90 minutes / 1.5 Hours</td>
                      </tr>-->
        
                      <tr>
                        <td>Soft Skills and English communication</td>
                          <td>25 </td>
                        <td>90 minutes / 1.5 Hours</td>
                      </tr>
        
                    </table>
            </section>

          </div>

  </div>

<hr>

<div class="row download_section">
  <div class="col-md-12">
      <h2>Response Sheet of Examinations</h2>
  </div>
</div>

  <div class="row">

          <div class="col-md-12 step_cls">
           
            <h3>The response sheets of CBT exams conducted by NIMI can be accessed in the following link <a target="_blank" href="https://nimionlineadmission.in/aitt/resultlogin.php">Click here</a> . </h3> 

          </div>

  </div>


    </div>




<style>
    .banner_header{
        background: #2955a9;
    padding: 10px 0px;
    text-align: left;
    color: #fff;
    margin: 0px;
    }
    .banner_header h2{
        font-size: 21px;
    }
    .download_section{
        padding: 40px 0px 0px;
        text-align: center;
    }
    .dwn_btm{
        padding-bottom: 60px;
    }
    .steps{
        left: 0px;
    height: 40px;
    width: 40px;
    background-color: #29ab55;
    border-radius: 50%;
    display: inline-block;
    font-size: 24px;
    text-align: center;
    color: #fff;
    position: absolute;
    }
    .step_cls{
        padding: 0px 70px 30px;
    }
    .click_here{
        background: #2955a9;
    padding: 5px 15px;
    color: #fff;
    font-size: 10px;
    font-weight: 500;
    border-radius: 10px;
    width: fit-content;
    cursor: pointer;
    }
    .click_here:hover{
        background-color: #000;
        text-decoration: none;
    }

   h4{
       border-bottom: 1px solid #000;
       width: fit-content;
       padding-bottom: 5px;
   }
   .big_padd{
       padding-bottom: 120px;
   }

   table{
      width: 100%;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #d9dfe1;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }

</style>
